import { chakra } from '@chakra-ui/react'

export const ThemeToggleContainer = chakra('div', {
    baseStyle: ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.palette.themeToggle.backgroundColor,
        padding: '24px 24px 32px',
    }),
})

export const ThemeSelectionTitle = chakra('div', {
    baseStyle: ({ theme }) => ({
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '28px',
        background: theme.palette.themeToggle.titleColor,
        padding: '16px 0',
        backgroundClip: 'text',
        textFillColor: 'transparent',
    }),
})
